<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const items = computed(() => contentAttributes.value?.items || []);

const linkAction = item => (item.actions || []).find(a => a.type === 'link');
</script>

<template>
  <BaseBubble class="overflow-hidden p-3" data-bubble-name="cards">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="grid gap-3 min-w-64"
      :class="{ 'mt-4': index > 0 }"
    >
      <div class="size-8 rounded-lg grid place-content-center bg-[#2781F6]">
        <Icon icon="i-ph-video-camera-fill" class="text-white size-4" />
      </div>
      <div class="space-y-1 overflow-hidden">
        <div v-if="item.title" class="truncate text-sm text-n-slate-12">
          {{ item.title }}
        </div>
        <div v-if="item.description" class="truncate text-sm text-n-slate-11">
          {{ item.description }}
        </div>
      </div>
      <div v-if="linkAction(item)" class="grid gap-2">
        <a
          :href="linkAction(item).uri"
          target="_blank"
          rel="noreferrer noopener nofollow"
          class="w-full block text-center px-4 py-2 rounded-full text-sm font-medium bg-[#000000] text-white hover:bg-n-slate-11"
        >
          {{ linkAction(item).text }}
        </a>
      </div>
    </div>
  </BaseBubble>
</template>

